import { useDynamicHTML } from '../../hooks/useDynamicHTML';

/**
 * Composant qui met à jour dynamiquement les éléments <head> du HTML
 * en fonction du tenant actuel (multi-tenant par domaine)
 * 
 * Ce composant doit être placé à la racine de l'application,
 * à l'intérieur du TenantProvider
 */
export function DynamicHTMLHead() {
  useDynamicHTML();
  return null; // Ce composant ne rend rien visuellement
}
